"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React, { useState } from "react";
import { ChevronDown, CircleCheck, CircleAlert, GraduationCap, BookOpen } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Link } from "@/components/common/Link";
const childrenData = [{
  id: "child-1",
  firstName: "Jakarta",
  lastName: "Pusat",
  grade: "Sudirman - Thamrin",
  classroom: "08:00 - 11:00 WIB",
  status: "Aktif",
  statusType: "positive",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/razia_jakarta_pusat.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/razia_jakarta_pusat.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/razia_jakarta_pusat.png-wvc-sizes",
    alt: "Info Razia Jakarta Pusat"
  }
}, {
  id: "child-2",
  firstName: "Bekasi",
  lastName: "Kota",
  grade: "Jl. Ahmad Yani",
  classroom: "Selesai",
  status: "Tidak Aktif",
  statusType: "warning",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/razia_bekasi_kota.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/razia_bekasi_kota.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/razia_bekasi_kota.png-wvc-sizes",
    alt: "Info Razia Bekasi"
  }
}];
export default function InfoRaziaHariIni() {
  const [selectedChildId, setSelectedChildId] = useState<string>(childrenData[0].id);
  const selectedChild = childrenData.find(child => child.id === selectedChildId) || childrenData[0];
  return <section data-section-id="252635" id="info-razia-hari-ini" className="w-full py-12 md:py-16 lg:py-20 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-default text-foreground uppercase tracking-tight">
              INFO RAZIA HARI INI
            </h2>
            <p className="text-muted-foreground mt-1 font-sans">
              Pantau titik pemeriksaan lalu lintas terkini
            </p>
          </div>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="w-full sm:w-auto justify-between gap-4 bg-card border-primary/20 hover:bg-accent">
                <div className="flex items-center gap-2">
                  <SafeHydrate><Avatar className="size-6 border border-border">
                    <AvatarImage src={selectedChild.image.src} alt={selectedChild.firstName} />
                    <AvatarFallback className="text-xs bg-primary text-primary-foreground">{selectedChild.firstName[0]}</AvatarFallback>
                  </Avatar></SafeHydrate>
                  <span className="font-default font-semibold">{selectedChild.firstName}</span>
                </div>
                <ChevronDown className="size-4 text-primary" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-[240px] bg-popover border-border">
              <DropdownMenuLabel className="font-default">Pilih Wilayah</DropdownMenuLabel>
              <DropdownMenuSeparator />
              {childrenData.map((child, index) => <DropdownMenuItem key={child.id} data-index={index} onClick={() => setSelectedChildId(child.id)} className="flex items-center gap-3 cursor-pointer py-2 hover:bg-accent">
                  <SafeHydrate><Avatar className="size-8 border border-border">
                    <AvatarImage src={child.image.src} alt={child.firstName} />
                    <AvatarFallback className="bg-muted text-muted-foreground">{child.firstName[0]}</AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div className="flex flex-col">
                    <span className="font-default font-bold text-sm">{child.firstName} {child.lastName}</span>
                    <span className="text-xs text-muted-foreground font-sans">{child.grade}</span>
                  </div>
                  {selectedChildId === child.id && <CircleCheck className="size-4 ml-auto text-primary" />}
                </DropdownMenuItem>)}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>

        <Card className="overflow-hidden border-l-4 border-l-primary border-y-border border-r-border shadow-md bg-gradient-to-br from-card to-accent/30">
          <CardContent className="p-0">
            <div className="flex flex-col md:flex-row">
              
              {}
              <div className="md:w-1/3 bg-accent/20 p-8 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r border-border">
                <div className="relative mb-6">
                  <div className="absolute inset-0 bg-primary/5 rounded-lg blur-xl transform scale-110"></div>
                  <img src={selectedChild.image.src} data-wvc-srcset={selectedChild.image.srcset} data-wvc-sizes={selectedChild.image.sizes} alt={selectedChild.image.alt} loading="lazy" className="relative size-40 md:size-48 rounded-lg object-cover border-2 border-background shadow-sm z-10" />
                </div>
                
                <Button asChild variant="default" className="w-full rounded-md font-default font-bold bg-primary hover:bg-primary/90 text-primary-foreground">
                  <Link to="#">Detail Laporan</Link>
                </Button>
              </div>

              {}
              <div className="md:w-2/3 p-8 md:p-10 flex flex-col justify-center relative">
                <CircleAlert className="absolute top-4 right-4 size-6 text-primary/20" />
                
                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4 mb-6">
                  <div>
                    <h3 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-2">
                      {selectedChild.firstName} {selectedChild.lastName}
                    </h3>
                    <div className="flex flex-wrap items-center gap-3 text-muted-foreground font-sans">
                      <div className="flex items-center gap-1.5">
                        <GraduationCap className="size-5 text-primary" />
                        <span className="font-medium">{selectedChild.grade}</span>
                      </div>
                      <span className="hidden sm:inline text-border">•</span>
                      <div className="flex items-center gap-1.5">
                        <BookOpen className="size-5 text-primary" />
                        <span>{selectedChild.classroom}</span>
                      </div>
                    </div>
                  </div>
                  
                  <Badge variant={selectedChild.statusType === 'positive' ? 'default' : 'secondary'} className={`text-sm py-1.5 px-4 shadow-sm font-default font-bold ${selectedChild.statusType === 'warning' ? 'bg-muted text-muted-foreground' : 'bg-green-600 text-white hover:bg-green-700'}`}>
                    {selectedChild.statusType === 'positive' ? <CircleCheck className="size-4 mr-1.5" /> : <CircleAlert className="size-4 mr-1.5" />}
                    {selectedChild.status}
                  </Badge>
                </div>

                <div className="space-y-4">
                  <h4 className="text-sm font-bold text-foreground uppercase tracking-widest font-default">Catatan Petugas</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div className="bg-card rounded-md p-4 border border-border shadow-sm">
                      <p className="text-sm font-bold font-default text-foreground mb-1">Kelengkapan Surat</p>
                      <p className="text-xs text-muted-foreground font-sans">Pemeriksaan rutin STNK dan SIM bagi pengendara roda dua.</p>
                    </div>
                    <div className="bg-card rounded-md p-4 border border-border shadow-sm">
                      <p className="text-sm font-bold font-default text-foreground mb-1">Arus Lalu Lintas</p>
                      <p className="text-xs text-muted-foreground font-sans">Terpantau padat merayap di sekitar lokasi pemeriksaan.</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </CardContent>
        </Card>

      </div>
    </section>;
}